import React from 'react'
import styled from 'styled-components'
import GlobalStyle from '../../../utils/createGlobalStyle'
import LiveTooltip from 'live/components/ui/tooltip'
import { Separator } from '../../../Separator/Separator'

type Props = {
    availabilitys: Availability[] // availabilityList // TODO: typo `availabilities`
    className?: string
    /**
     * @default 0.2
     */
    opacity?: number
}

type Availability = {
    title: string
    subtitle: string
    color: string
}

// import AvailabilityGraphDaily from 'plugin-smart-mobility-utils/shared/ui/Widget/AvailabilityGraphDaily/AvailabilityGraphDaily'
const AvailabilityGraphDaily = ({ availabilitys: availabilities, ...props }: Props): JSX.Element => {
    return (
        <Wrapper opacity={0.2} {...props}>
            <GlobalStyle />
            {availabilities?.map((availability, index) => {
                return (
                    <LiveTooltip
                        key={index}
                        position="top"
                        className={'tooltip-graph'}
                        content={getTooltipContent(availability)}
                    >
                        <DivDataInfo key={index} color={availability?.color} width={100 / availabilities.length} />
                    </LiveTooltip>
                )
            })}
        </Wrapper>
    )
}

export default AvailabilityGraphDaily

const DivDataInfo = styled.div`
    background: ${({ color }) => color};
    width: ${({ width }) => width}%;
    height: 24px;
    border-radius: 3px;
    border: none;

    &&&:hover {
        opacity: 1;
    }
`

const Wrapper = styled.div`
    margin: 0;
    padding: 0;
    display: flex;
    text-transform: uppercase;
    gap: 1px;
    font-family: 'SourceSansPro-SemiBold', sans-serif;

    :hover {
        ${DivDataInfo} {
            opacity: ${({ opacity }) => opacity};
        }
    }
`

const DivTooltip = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const DataInfo = styled.div`
    font-family: 'SourceSansPro-SemiBold', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 15px;
    color: ${({ theme }) => theme['gray-0']};
`

const DivPercentualInfo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
`

const InfoStatusCircle = styled.div`
    background-color: ${({ color }) => color};
    border-radius: 50%;
    width: 8px;
    height: 8px;
`

const InfoStatusSpan = styled.span`
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme['gray-0']};
    font-family: 'SourceSansPro-SemiBold', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 16.8px;
`

const getTooltipContent = (availability: Availability): JSX.Element => {
    return (
        <DivTooltip className="tooltip-graph-content">
            <div className="custom-tooltip-content-inner">
                <DataInfo>{availability?.title}</DataInfo>
                <Separator
                    orientation={'horizontal'}
                    width="100%"
                    height="1px"
                    color={'#DCDEE2'}
                    style={{ margin: 0, padding: 0 }}
                />
                <DivPercentualInfo>
                    <InfoStatusCircle color={availability?.color} />
                    <InfoStatusSpan> {availability?.subtitle} </InfoStatusSpan>
                </DivPercentualInfo>
            </div>
        </DivTooltip>
    )
}
